import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { AppNotificationService } from '@core/services/app-notification.service';
import { ConfirmDialogService } from '@shared/components/dialogs/confirm-dialog/confirm-dialog.service';
import { U2bValidators } from '@shared/validators/validators';
import { CompaniesService } from '@modules/bcm/companies/companies.service';
import { CompanyContact } from '@shared/models/company-contact';
import { TranslationService } from '@core/translation/translation.service';

@Component({
    selector: 'company-contact',
    templateUrl: './company-contact.component.html',
    styleUrls: ['./company-contact.component.scss'],
    standalone: false
})
export class CompanyContactComponent {

    formGroup: UntypedFormGroup;

    isSaving: boolean;

    contact: CompanyContact;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                private _dialogRef: MatDialogRef<CompanyContactComponent>,
                private _appNotificationService: AppNotificationService,
                private _confirmDialogService: ConfirmDialogService,
                private _companiesService: CompaniesService,
                private _formBuilder: UntypedFormBuilder) {
        this._dialogRef.addPanelClass('default-dialog');
        this._dialogRef.disableClose = true;

        this.contact = {...data};

        this.formGroup = this._formBuilder.group({
            note: [this.contact?.note || null, [U2bValidators.maxLength(1024)]]
        });

    }

    onClickClose(): void {

        if (this.formGroup.dirty) {
            return this._confirmDialogService
                .useWarnTheme()
                .setTitle(TranslationService.translate('common.confirm.attention'))
                .setBody(TranslationService.translate('common.unsavedChanges.leavePageBody'))
                .setYesButton({
                    text: TranslationService.translate('common.unsavedChanges.leavePageConfirmYes')
                })
                .setNoButton({
                    text: TranslationService.translate('common.cancel')
                })
                .openWithCallback(() => this._dialogRef.close());
        }

        this._dialogRef.close();
    }

    onClickSaveAndClose(): void {
        if (this.formGroup.invalid) {
            this.formGroup.markAllAsTouched();
            this._appNotificationService.showError(TranslationService.translate('common.checkFieldsHighlight'));
        } else {

            const {
                companyContactForm,
                note
            } = this.formGroup.value;

            const companyContact: CompanyContact = {
                id: this.contact.id || null,
                companyId: this.contact.companyId || null,
                personId: (companyContactForm.person) ? companyContactForm.person.id : null,
                personName: (companyContactForm.person) ? companyContactForm.person.fullName : companyContactForm.personName,
                personMail: (companyContactForm.person) ? companyContactForm.person.mail : companyContactForm.personMail,
                personPhone: (companyContactForm.person) ? companyContactForm.person.phone : companyContactForm.personPhone,
                note: note
            };

            // check if contact already exists
            const contactExists = this.data.company.companyContacts.findIndex(existingContacts => {
                return existingContacts.personId !== null && (existingContacts.personId === companyContact.personId);
            }) !== -1;

            if (contactExists) {
                this._appNotificationService.showError(TranslationService.translate('bcm.companyContact.error.personAlreadyLinked'));
                return;
            }

            this._dialogRef.close(companyContact);
        }
    }
}
